module.exports = global["pdfMake"] = require("-!.\\pdfMake.js");


// WEBPACK FOOTER //
// webpack:///src/browser-extensions/pdfMake.js-exposed